/**
 * Created by Arif Topcu in 2019
 */

import React, { memo } from "react";
import PropTypes from "prop-types";
import styles from "./MiniBetaSelectorComplication.module.css";
import Combobox from "@ls/react-combobox-grid";
import CovarianceType from "state/selections/Constants/CovarianceType";
import PivotBetaDefinition from "state/pivots/PivotBetaDefinition";
import { selectBetaDecodesSelectionOptions } from "state/betas/selectors";
import { useSelector } from "react-redux";

const covarianceOptions = Object.values(CovarianceType);

const MiniBetaSelectorComplication = ({ setNewBeta, betaDefinition }) => {
  const { betaId, covarianceType } = betaDefinition;
  const betaDecodesSelectionOptions = useSelector(
    selectBetaDecodesSelectionOptions
  );

  return (
    <div className={styles.root}>
      <div className={styles.selector}>
        <Combobox
          label="Beta:"
          labelPosition={"TOP"}
          value={betaId}
          options={betaDecodesSelectionOptions}
          placeholder="Select Beta..."
          onChange={(betaId) =>
            setNewBeta(
              new PivotBetaDefinition({
                betaId,
                covarianceType,
              })
            )
          }
          size={"S"}
          variation={0}
          clearable={false}
        />
      </div>
      <div className={styles.selector}>
        <Combobox
          label="Covariance Type:"
          labelPosition={"TOP"}
          value={covarianceType}
          options={covarianceOptions}
          placeholder="Select Covariance..."
          onChange={(covarianceType) =>
            setNewBeta(
              new PivotBetaDefinition({
                betaId,
                covarianceType,
              })
            )
          }
          gridHeight={100}
          size={"S"}
          variation={0}
          clearable={false}
        />
      </div>
    </div>
  );
};

MiniBetaSelectorComplication.propTypes = {
  setNewBeta: PropTypes.func.isRequired,
  betaDefinition: PropTypes.object.isRequired,
};

export default memo(MiniBetaSelectorComplication);
